import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-modal-increase-column',
  templateUrl: './modal-increase-column.component.html',
  styleUrls: ['./modal-increase-column.component.scss']
})
export class ModalIncreaseColumnComponent implements OnInit {
  @Input() isMobile: boolean = false;
  @Input() column: string | null = null; // The column to increase
  @Input() columnLabel: string | null = null;
  @Input() selectedItems: any[] = []; // The selected rows to apply the increase
  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() onApply: EventEmitter<{ value: number; unit: 'percentage' | 'value' }> = new EventEmitter();

  inputValue: string = '';
  value: number | null = null; // The value to increase by
  unit: 'percentage' | 'value' = 'percentage'; // The unit of increase (percentage or value)
  optionsList: SelectOption[] = new Array();

  ngOnInit(): void {
    this.initOptionsList();
  }

  capitalizeFirstLetter(str: string) {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  initOptionsList(): void {


    const opt1 = new SelectOption();
    opt1.text = 'value';
    opt1.value = 'value';
    opt1.isDefault = false;

    const opt2 = new SelectOption();
    opt2.text = 'percentage';
    opt2.value = 'percentage';
    opt2.isDefault = true;

    this.optionsList.push(opt1);
    // if the field is expressed as percentage the only option will be increase by value
    if (!this.columnLabel?.includes('%')) {
      this.optionsList.push(opt2);
    }
    else {
      this.optionsList[0].isDefault = true; // only increase by value => set as default 
    }

  }

  closeModal(): void {
    this.onClose.emit();
  }

  applyIncrease(): void {
    if (this.value === null || isNaN(this.value)) {
      return;
    }
    this.onApply.emit({ value: this.value, unit: this.unit });
  }

  onInputValue(value: string) {
    // Allow "-" or "." or "-." as temporary values
    if (value === "-" || value === "." || value === "-.") {
      this.inputValue = value;
      return;
    }

    // Ensure the value is a valid number
    const numericValue = Number(value);
    if (!isNaN(numericValue)) {
      this.value = numericValue;
      this.inputValue = value; // Keep the string representation for the input
    }
  }

  onUnitChange(unit: 'percentage' | 'value') {
    this.unit = unit;
  }
}
